import { Platform } from "react-native";
import * as NavigationBar from "expo-navigation-bar";

import { palette } from "@/theme/palette";

export async function setAndroidNavigationBar(theme: "light" | "dark") {
  if (Platform.OS !== "android") return;
  await NavigationBar.setButtonStyleAsync(theme === "dark" ? "light" : "dark");
  await NavigationBar.setBackgroundColorAsync(
    theme === "dark" ? palette.dark.background : palette.light.background,
  );
}
